import { useEffect, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import {
    FaAddressBook,
    FaBriefcase,
    FaRobot
} from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";

import DashboardLayout from "./DashboardLayout ";
import EvergreenJobs from "./EvergreenJobs";
import GlobalHRSettings from "./GlobalHRSettings";
import MyJobs from "./MyJobs";
import AIJobsByJobbox from "./AIJobsByJobbox";

const customTabHeader = (title, icon) => (
    <div className="d-flex align-items-center">
        <span className="me-2">
            {icon}
        </span>
        <span className="fs-6 fw-bold">{title}</span>
    </div>
);

const HRPostedJobs = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const initialTab = location.state?.activeTab;
    const storedTab = localStorage.getItem("activeHRPostedJobTab");

    const [activeTab, setActiveTab] = useState(
        initialTab || storedTab || "myJobs"
    );

    // Handle tab selection
    const handleTabClick = (key) => {
        setActiveTab(key);

        // Save selected tab
        localStorage.setItem("activeHRPostedJobTab", key);

       
    };

    useEffect(() => {
        if (location.state?.activeTab) {
            setActiveTab(location.state.activeTab);

            localStorage.setItem(
                "activeHRPostedJobTab",
                location.state.activeTab
            );
        }
    }, [location.state]);

    return (
        <DashboardLayout>
            <div className="main-content">

                <Row
                    className="d-flex justify-content-between align-items-center"
                    style={{ marginBottom: "20px" }}
                >
                    <Col xs="auto">
                        <h2
                            className="text-start"
                            style={{ marginLeft: "12px" }}
                        >
                            My Jobs
                        </h2>
                    </Col>

                    <Col xs="auto">
                        <GlobalHRSettings />
                    </Col>
                </Row>

                <Row>
                    <Col style={{ marginLeft: "12px" }}>

                        <Tabs
                            activeKey={activeTab}
                            onSelect={handleTabClick}
                            style={{ marginBottom: "20px" }}
                        >

                            {/* My Jobs */}
                            <Tab
                                eventKey="myJobs"
                                title={customTabHeader(
                                    "My Jobs",
                                    <FaAddressBook />
                                )}
                            >
                                <MyJobs />
                            </Tab>

                            {/* Evergreen Jobs */}
                            <Tab
                                eventKey="evergreenJobs"
                                title={customTabHeader(
                                    "Evergreen Jobs",
                                    <FaBriefcase />
                                )}
                            >
                                <EvergreenJobs />
                            </Tab>

                            {/* AI Jobs by Jobbox */}
                            <Tab
                                eventKey="aiJobs"
                                title={customTabHeader(
                                    "AI Jobs by Jobbox",
                                    <FaRobot />
                                )}
                            >
                                <AIJobsByJobbox />
                            </Tab>

                        </Tabs>

                    </Col>
                </Row>

            </div>
        </DashboardLayout>
    );
};

export default HRPostedJobs;